import React from 'react';
import * as PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSave,
  faSync,
  faExclamationTriangle,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';

import './ConceptStatus.sass';

const ConceptStatus = ({ saving, dirty, conceptName, autoSave }) => {
  let mainClasses = 'concept-status';
  let icon = faSave;
  let iconSpin = false;
  let title = 'Your design has not been saved';

  if (saving === true) {
    mainClasses += ' saving';
    icon = faSync;
    iconSpin = true;
    title = 'Saving your changes...';
  } else if (dirty === true) {
    mainClasses += ' dirty';
    title = 'You have unsaved changes';
  } else if (conceptName.length > 0) {
    mainClasses += ' saved';
    title = 'All changes have been saved';
  } else {
    mainClasses += ' untitled';
  }

  return (
    <div className={mainClasses}>
      <div className="concept-icon">
        <OverlayTrigger
          key="status"
          placement="top"
          overlay={<Tooltip id="tooltip-status">{title}</Tooltip>}
        >
          <Button
            variant="link"
            className="p-0 border-0"
            aria-label={title}
            tabIndex="0"
          >
            <FontAwesomeIcon icon={icon} spin={iconSpin} />
          </Button>
        </OverlayTrigger>
      </div>
      <div className="concept-name">
        {conceptName.length ? conceptName : '(unsaved design)'}
      </div>
      {!autoSave && (
        <div className="concept-autosave">
          <OverlayTrigger
            key="autosave"
            placement="top"
            overlay={
              <Tooltip id="tooltip-autosave">Autosave is disabled</Tooltip>
            }
          >
            <Button
              variant="link"
              className="p-0 border-0"
              aria-label="Autosave is disabled"
              tabIndex="0"
            >
              <FontAwesomeIcon icon={faExclamationTriangle} color="red" />
            </Button>
          </OverlayTrigger>
        </div>
      )}
    </div>
  );
};
ConceptStatus.propTypes = {
  saving: PropTypes.bool,
  dirty: PropTypes.bool,
  conceptName: PropTypes.string,
  autoSave: PropTypes.bool,
};

ConceptStatus.defaultProps = {
  saving: false,
  dirty: false,
  conceptName: '',
  autoSave: true,
};

export default ConceptStatus;
